import { File } from './file'

export class Setting{
    tel:string
    phone:string
    email:string
    address:string
    slideBackgroundImage:File
    slideForegroundImage:File
    facebookLink:string
    youtubeLink:string
    linkedInLink:string
    telegramLink:string
    tiktokLink:string
}